import React, { useState,useEffect } from 'react';
import Heading from '../heading';
import Input from '@/components/atoms/input';
import Button from '@/components/atoms/button';
import AddressesStep from '../../steps/addresses';
import Typography from '@/components/atoms/typography';
import Radio from '@/components/atoms/radio';
import { useStoreAndBusinessUnits } from '@/providers/store-and-business-units';
import { sdk } from '@/sdk/CommercetoolsSDK';
import Spinner from '@/components/organisms/spinner';
import useTranslation from '@/providers/I18n/hooks/useTranslation';
import Accordion from '@/components/molecules/accordion';
import Markdown from '@/components/atoms/markdown';
import { useParams } from 'next/navigation';

const CheckoutBody = ({
  addresses,
  initialData = {},
  details,
  setDetails,
  shippingMethods,
  error,
  setError,
  validateForm,
  setValidateForm
}: any) => {
  const [loading, setLoading] = useState(false);
  const { locale } = useParams();


  const handleChange = async (e: any) => {
    const { name, value } = e.target;
    setDetails((prev: any) => ({
      ...prev,
      [name]: value,
    }));

  };


  const handleRadioButton = (name: string, key: string) => {
    setDetails((prev: any) => {
      return {
        ...prev,
        shippingMethod: key,
        // ShippingMethodKey: key,
      };
    });
    setError((prev: any) => {
      return {
        ...prev,
        shippingMethod: '',
      };
    });
    setValidateForm(false)
  };

useEffect(() => {
  if (
    shippingMethods?.length > 0 &&
    !details?.shippingMethod
  ) {
    setDetails((prev: any) => ({
      ...prev,
      shippingMethod: shippingMethods[0]?.key,
    }));
  }
}, [shippingMethods]);
  return (
    <>
      {loading && <Spinner />}
      {loading && <div className="overlay fixed left-0 top-0 z-50 h-full w-full bg-gray-800 opacity-75"></div>}
      <div className="max-w-[1388px] mx-auto lg:px-6">
        <div
          className="mt-[5px] border-b-[2px] border-[#EFF0F2] bg-white px-3 pb-6 pt-4 sm:mt-0 sm:px-0 sm:pb-[67px] sm:pt-[60px]"
          id="delivery-address"
        >
          <Heading content="1. Customer Information" />
          <div id='customer-information' className="mt-4 sm:mt-12">
            <AddressesStep
              initialData={initialData}
              setDetails={setDetails}
              details={details}
              validateForm={validateForm}
              setValidateForm={setValidateForm}
              addresses={addresses}
            />
          </div>
        </div>
        <div
          className="mt-[5px] border-b-[2px] border-[#EFF0F2] bg-white px-3 pb-7 pt-4 sm:px-0 md:pb-[52px] md:pt-[60px]"
          id="delivery-method"
        >
          <Heading content="2. Delivery Method" />
          {locale === 'au' ? (
            <div className="mt-7 flex flex-col gap-5 sm:mt-[50px] sm:gap-[27px]">
              {shippingMethods?.map((method: any) => {
                if (!method?.description) return null;
                const isSelected = details?.shippingMethod === method?.key;
                return (
                  <div key={method?.key} onClick={() => handleRadioButton(method?.name, method?.key)}>
                    <Accordion
                      isExpanded={isSelected}
                      className={`cursor-pointer flex flex-col border !border-black px-[25px] py-[23px] sm:px-[42px] sm:py-[17px] ${isSelected ? 'bg-[#EFF0F2]' : 'bg-white'}`}
                    >
                      {/* Above md: Radio, Name and Description in same line */}
                      <div className='flex items-center w-full gap-[12px]'>
                        <Accordion.Button withArrow={false} className="items-center justify-center cursor-pointer no-arrow flex-shrink-0 !w-[39px]">
                          <Radio
                            className="m-1 !h-[27px] !w-[27px] !accent-black"
                            checked={isSelected}
                            readOnly
                          />
                        </Accordion.Button>

                        {/* Below md: Radio and Name in one line, Description in second line */}
                        <div className="md:ml-[20px] [&>div:first-child]:!h-auto">
                          <Typography className="text-17 !font-bold !leading-6 !text-black sm:!text-20 ">
                            {method?.name}
                          </Typography>

                          {/* Description - hidden on mobile, inline on desktop */}
                          <Accordion.Panel className='!px-0 text-17 hidden md:block sm:!text-20 flex-1 !pb-0 '>
                            <Markdown>
                              {method?.description}
                            </Markdown>
                          </Accordion.Panel>
                        </div>
                      </div>

                      {/* Description on mobile - below the name */}
                      <Accordion.Panel className='!px-0 !pl-[12px] text-17 block md:hidden sm:!text-20'>
                        <Markdown>
                          {method?.description}
                        </Markdown>
                      </Accordion.Panel>
                    </Accordion>
                  </div>
                );
              })}
              {error?.shippingMethod && (
                <span className="block text-xs font-normal leading-4 text-[#E32C53]">Please select one of the Delivery Options!</span>
              )}
            </div>
          ) : (
            <div className="mt-7 flex flex-col gap-5 sm:mt-[50px] sm:gap-[27px]">
              {shippingMethods?.map((method: any) => {
                if (!method?.description) return null;
                const isSelected = details?.shippingMethod === method?.key;
                return (
                  <div
                    key={method?.key}
                    onClick={() => handleRadioButton(method?.name, method?.key)}
                    className={`flex flex-col cursor-pointer border border-black px-[25px] py-[23px] sm:px-[42px] sm:py-[17px] ${isSelected ? 'bg-[#EFF0F2]' : 'bg-white'}`}
                  >
                    {/* Above md: Radio, Name and Description in same line */}
                    <div className="flex items-center w-full gap-[12px]">
                      <Radio
                        className="m-1 !h-[27px] !w-[27px] !accent-black"
                        checked={isSelected}
                      />

                      {/* Below md: Name next to radio, Description below */}
                      <div className="">
                        <Typography className="text-17 !font-bold !leading-6 !text-black sm:!text-20">
                          {method?.name}
                        </Typography>

                        {/* Description - hidden on mobile, inline on desktop */}
                        <div className="hidden md:block mt-2">
                          <Typography className="text-17 !font-[300] !leading-6 !text-black sm:!text-20">
                            {method?.description}
                          </Typography>
                        </div>
                      </div>
                    </div>

                    {/* Description on mobile - below the name */}
                    <div className="block md:hidden mt-2 !pl-[12px]">
                      <Typography className="text-17 !font-[300] !leading-6 !text-black sm:!text-20">
                        {method?.description}
                      </Typography>
                    </div>
                  </div>
                );
              })}
              {error?.shippingMethod && (
                <span className="block text-xs font-normal leading-4 text-[#E32C53]">Please select one of the Delivery Options!</span>
              )}
            </div>
          )}




        </div>
        <div className="mt-[5px] bg-white px-3 pb-5 pt-4 sm:px-0 sm:pb-[67px] sm:pt-[60px]" id="other-details">
          <Heading content="3. Other Details" />
          <div className="mt-5 sm:mt-[54px]">
            <textarea
              name="DeliveryInstructions"
              onChange={(e) => {
                setDetails((prev: any) => ({
                  ...prev,
                  deliveryInstructions: e.target.value,
                }));
              }}
              placeholder="Any shipping instructions or other information for our team?"
              value={details?.deliveryInstructions}
              maxLength={300}
              autoComplete=""
              className="border-1 h-[190px] focus:outline-none active:outline-none ring-0 focus:ring-0 w-full rounded-[6px] !border-[#D7D7D7] pb-10  pt-2 text-left text-[#000000] !text-[20px] placeholder:text-[#828282]"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckoutBody;
